import { render, staticRenderFns } from "./ResumeCard.vue?vue&type=template&id=d4f356d0&scoped=true&"
import script from "./ResumeCard.vue?vue&type=script&lang=ts&"
export * from "./ResumeCard.vue?vue&type=script&lang=ts&"
import style0 from "./ResumeCard.vue?vue&type=style&index=0&id=d4f356d0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f356d0",
  null
  
)

export default component.exports